import { Tag } from 'antd';
import type { ReadinessChecklist } from '../../../jobs.api';

interface ReadinessSummaryProps {
  readiness: ReadinessChecklist;
}

/** The readiness checklist's overall state (gitaumoses4/chukua#36) — shared by the Readiness tab and job intake's own summary, never a blocking gate on the job's state transitions. */
export function ReadinessSummary({ readiness }: ReadinessSummaryProps) {
  const unmetCount = readiness.items.filter((item) => !item.met).length;
  return (
    <div className="flex items-center gap-2">
      <Tag color={readiness.ready ? 'success' : 'default'}>{readiness.ready ? 'Ready' : 'Not ready'}</Tag>
      <span className="text-sm text-muted">
        {unmetCount} of {readiness.items.length} item(s) not yet met
      </span>
    </div>
  );
}
